import EnvConfig from 'env.config';
import { ApiService } from 'services';

import { handleException } from 'actions/exceptions';
import { getUserConfig } from './getUserConfig';

export const AUTH_STATE_REQUEST = 'AUTH_STATE_REQUEST';
export const AUTH_STATE_SUCCESS = 'AUTH_STATE_SUCCESS';
export const AUTH_STATE_FAILURE = 'AUTH_STATE_FAILURE';
export const AUTH_STATE_UNAUTHORISED = 'AUTH_STATE_UNAUTHORISED';
export const SET_AUTH_STATE = 'SET_AUTH_STATE';

function request() {
  return {
    type: AUTH_STATE_REQUEST
  };
}

function receive(token, sessionAuthMode) {
  return {
    type: AUTH_STATE_SUCCESS,
    isFetching: false,
    isAuthenticated: true,
    token,
    sessionAuthMode
  };
}

function reject() {
  return {
    type: AUTH_STATE_FAILURE
  };
}

function unauthorised() {
  return {
    type: AUTH_STATE_UNAUTHORISED
  };
}

function setAuth(state) {
  return {
    type: SET_AUTH_STATE,
    state
  };
}

export function getAuthState() {
  return (dispatch) => {
    dispatch(request());

    const promise = () => ApiService
      .getAuthState()
      .then((response) => {
        const { token, sessionAuthMode } = response.data;
        const originalToken = sessionStorage.getItem(EnvConfig.firstTokenName);
        if (!originalToken) {
          sessionStorage.setItem(EnvConfig.firstTokenName, token);
        }
        sessionStorage.setItem(EnvConfig.tokenName, token);
        dispatch(receive(token, sessionAuthMode));
        dispatch(getUserConfig());
      }).catch((error) => {
        if (!error.response) {
          ApiService.addQueuedPromise(promise, error);
        }
        if (error.response) {
          if (error.response.data.code === 403) {
            dispatch(handleException(error, unauthorised, false));
          } else if (error.response.status === 401) {
            dispatch(reject());
          } else {
            dispatch(handleException(error, reject, false));
          }
        } else if (error.retries && error.retries > 1) {
          dispatch(handleException(error, reject, false));
        }
      });
    return promise();
  };
}

export function setAuthState(state) {
  return dispatch => dispatch(setAuth(state));
}
